<template>
    <div class="container is-fluid">
        <div class="columns">
            <div class="column">
                <app-table></app-table>
            </div>
        </div>
    </div>
</template>

<script>
    import FavoritesTable from './FavoritesTable'
    export default {
        components: {
            appTable: FavoritesTable
        }
    }
</script>

<style scoped>
    .container {
        margin-top: 25px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Favorites/FavoritesList.vue